import LineString from "ol/geom/LineString";
import Point from "ol/geom/Point";
import PreUndoData from "./PreUndoData";
import * as _ from 'lodash'
import { TrackEntity } from "./TrackEntity";
import Feature from "ol/Feature";
import LineStringFeature from "./LineStringFeature";

export default class ReinstateTrackData extends PreUndoData {
    constructor(trackId: string, dotLngLats: Point[], trackLngLatFeatures: LineStringFeature[], name: string, colour: string, type: string, zIndex: number) {
        super()
        this.trackId = trackId
        this.dotLngLats = _.cloneDeep(dotLngLats) // if we don't clone, then if the array gets reversed, the copy in here will get reversed too, which we don't want
        this.trackLngLatFeatures = _.cloneDeep(trackLngLatFeatures)
        this.name = name
        this.type = type
        this.colour = colour
        this.zIndex = zIndex
    }
    trackId: string
    dotLngLats: Point[]
    trackLngLatFeatures: LineStringFeature[]
    name: string
    type: string
    colour: string
    zIndex: number
}